const setMirchiTop20List = data => ({
  type: "SET_MIRCHITOP20_LIST",
  data
});

export const mutation = {
  setMirchiTop20List
};
